import toSnakeCaseKeys from 'snakecase-keys';
import { mapState } from 'vuex';

export default {
  include: {
    ...mapState([
      'institution',
      'queroPagoRecipient',
    ]),
    isEditOperation() {
      return !!this.rule;
    },
    bussinessRuleGroupGetRawValue() {
      return toSnakeCaseKeys({
        ...this.businessRuleGroup.getRawValue(),
        splitRules: [
          { ...this.queropagoSplitRule.getRawValue() },
          { ...this.splitRule.getRawValue() },
        ],
        dueDayRule: {
          ...this.dueDayRule.getRawValue(),
          dueDays: this.dueDayRule.get('dueDays').value.split(','),
        },
        paymentMethodRules: { ...this.paymentMethodRules.getRawValue() },
        contractDischargeRules: { ...this.contractDischargeRules.getRawValue() },
        contractCreationRule: { ...this.contractCreationRule.getRawValue() },
        qbIntegrationRule: { ...this.qbIntegrationRule.getRawValue() },
        admissionPaymentRule: { ...this.admissionPaymentRule.getRawValue() },
        underpaymentRule: { ...this.underpaymentRule.getRawValue() },
        overpaymentRule: { ...this.overpaymentRule.getRawValue() },
        advancedPaymentDiscountRules: { ...this.advancedPaymentDiscountRules },
        chargesRule: { ...this.chargesRule.getRawValue() },
      });
    },
    isValidBusinessRuleGroup() {
      return !(this.businessRuleGroup.errors.length
        + this.splitRule.errors.length
        + this.dueDayRule.errors.length
        + this.paymentMethodRules.errors.length
        + this.contractDischargeRules.errors.length
        + this.contractCreationRule.errors.length
        + this.chargesRule.errors.length
        + this.admissionPaymentRule.errors.length
        + this.underpaymentRule.errors.length
        + this.overpaymentRule.errors.length
        + this.queropagoSplitRule.errors.length);
    },
  },
};
